<template>
  <div class="tooltip-container" @mouseenter="showTooltip" @mouseleave="hideTooltip">
    <slot></slot>
    <teleport to="body">
      <div
        v-if="visible"
        class="tooltip"
        :class="placementClass"
        :style="tooltipPosition"
      >
        {{ text }}
        <div class="tooltip-arrow" :class="arrowClass"></div>
      </div>
    </teleport>
  </div>
</template>


<script>
export default {
  name: "CustomTooltip",
  props: {
    text: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: "top", // Possible values: top, bottom, left, right
    },
  },
  data() {
    return {
      visible: false,
      tooltipPosition: {
        top: "0px",
        left: "0px",
      },
    };
  },
  computed: {
    placementClass() {
      return `tooltip-${this.placement}`;
    },
    arrowClass() {
      return `tooltip-arrow-${this.placement}`;
    },
  },
  methods: {
    showTooltip(event) {
      this.visible = true;

      // Add a delay to ensure DOM update (tooltip is rendered)
      this.$nextTick(() => {
          const rect = event.currentTarget.getBoundingClientRect();
          const tooltip = document.querySelector('.tooltip'); // Reference to the tooltip
          const tooltipWidth = tooltip.offsetWidth;
          const tooltipHeight = tooltip.offsetHeight;

          if (this.placement === "top") {
            this.tooltipPosition = {
              top: `${rect.top - tooltipHeight - 5}px`, // Add space between tooltip and element
              left: `${rect.left + rect.width / 2}px`,
              transform: "translateX(-50%)",
            };
          } else if (this.placement === "bottom") {
            this.tooltipPosition = {
              top: `${rect.bottom + 5}px`, // Add space between tooltip and element
              left: `${rect.left + rect.width / 2}px`,
              transform: "translateX(-50%)",
            };
          } else if (this.placement === "left") {
            this.tooltipPosition = {
              top: `${rect.top + rect.height / 2}px`,
              left: `${rect.left - tooltipWidth - 8}px`, // Add space between tooltip and element
              transform: "translateY(-50%)",
            };
          } else if (this.placement === "right") {
            this.tooltipPosition = {
              top: `${rect.top + rect.height / 2}px`,
              left: `${rect.right + 8}px`, // Add space between tooltip and element
              transform: "translateY(-50%)",
            };
          }
      });
    },
    hideTooltip() {
      this.visible = false;
    },
  },
};
</script>


<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip {
  position: absolute;
  background-color: rgba(31, 41, 55, 0.9);
  color: #fff;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  border-radius: 0.25rem;
  white-space: normal; /* Allows text wrapping */
  max-width: 250px; /* Ensures tooltip doesn't exceed this width */
  z-index: 9999;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  font-family: "Helvetica Neue", Arial, sans-serif;
  line-height: 1.4;
}

.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
}

/* Placement styles (arrow positions) */
.tooltip-arrow-top {
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-color: rgba(31, 41, 55, 0.9) transparent transparent transparent;
}

.tooltip-arrow-bottom {
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-color: transparent transparent rgba(31, 41, 55, 0.9) transparent;
}

.tooltip-arrow-left {
  left: 100%;
  top: 50%;
  margin-top: -5px;
  border-width: 5px;
  border-color: transparent rgba(31, 41, 55, 0.9) transparent transparent;
  transform: rotate(180deg);
}

.tooltip-arrow-right {
  right: 100%;
  top: 50%;
  margin-top: -5px;
  border-width: 5px;
  border-color: transparent transparent transparent rgba(31, 41, 55, 0.9);
  transform: rotate(180deg);
}
</style>
